import { JetView } from 'webix-jet';
import { devConfig, countries, providersCasino, subprovidersCasino, gamesCasino, profile } from 'config/config';

/**
 * Class representing the FilterMachineProductsView.
 * @extends JetView
 */
export default class FilterMachineProductsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const screen = this.app.config.size;

        // Left section containing provider and sub-provider selection
        const left = {
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'combo',
                            name: 'ProviderId',
                            localId: 'provider:combo',
                            label: _('Proveedor'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    /**
                                     * Fetches provider data based on user input.
                                     * @param {string} text - The input text for filtering providers.
                                     */
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        if (text.length > 2) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/ProvidersCasinoSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! ');
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (!resp.HasError) {
                                                                vthis.parse(resp.Data);
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'combo',
                            name: 'SubProviderId',
                            localId: 'subProvider:combo',
                            label: _('Sub Proveedor'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    /**
                                     * Fetches sub-provider data based on user input.
                                     * @param {string} text - The input text for filtering sub-providers.
                                     */
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        if (text.length > 2) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/SubProvidersCasinoSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! ');
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (!resp.HasError) {
                                                                vthis.parse(resp.Data);
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'richselect',
                            name: 'Categorie',
                            localId: 'categorie:combo',
                            label: "<span class='icon-category'></span>" + _('Categorías'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            id: 'Categorie',
                            options: [],
                        },
                    ],
                },
            ],
        };

        // Left section containing additional filters
        const left2 = {
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'IsVerified',
                            label: "<span class='icon-verified_user'></span>" + _('Verificado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: 'Todos' },
                                { id: 'A', value: 'Activado' },
                                { id: 'I', value: 'Inactivado' },
                            ],
                        },
                        {
                            view: 'richselect',
                            name: 'FilterCountry',
                            label: "<span class='icon-language'></span>" + _('Filtro País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: '', value: 'Todos' },
                                { id: 'A', value: 'Activado' },
                                { id: 'I', value: 'Inactivado' },
                            ],
                        },
                        {
                            view: 'text',
                            name: 'FeaturedOrder',
                            type: 'number',
                            label: "<span class='icon-reorder'></span>" + _('Orden Destacado'),
                            labelPosition: 'top',
                            placeholder: _('Orden Destacado'),
                            invalidMessage: _('Máximo is required'),
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Maximum',
                            type: 'number',
                            label: _('Máximo'),
                            labelPosition: 'top',
                            placeholder: _('Máximo'),
                            invalidMessage: _('Máximo is required'),
                        },
                        {
                            view: 'text',
                            name: 'Minimum',
                            type: 'number',
                            label: _('Mínimo'),
                            labelPosition: 'top',
                            placeholder: _('Mínimo'),
                            invalidMessage: _('Mínimo is required'),
                        },
                        {
                            view: 'text',
                            name: 'ProcessingTime',
                            type: 'number',
                            label: "<span class='icon-history'></span>" + _('Tiempo Procesamiento'),
                            labelPosition: 'top',
                            placeholder: _('Tiempo Procesamiento'),
                            invalidMessage: _('Tiempo Procesamiento is required'),
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'radio',
                            name: 'TypeDevice',
                            label: _('Dispositivo'),
                            labelPosition: 'top',
                            value: 3,
                            options: [
                                {
                                    id: 1,
                                    value: "<span class='icon-phone'></span>",
                                },
                                {
                                    id: 2,
                                    value: "<span class='icon-display'></span>",
                                },
                                { id: 3, value: 'Ambos' },
                            ],
                        },
                        { id: 'grav2', gravity: 1 },
                    ],
                },
            ],
        };

        // Upper section containing the left filters
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 370 : 0,
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };

        // Upper section containing additional filters
        const upper_section2 = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 500 : 0,
            rows: [
                {
                    margin: 10,
                    cols: [left2],
                },
            ],
        };

        // Accordion section for advanced filters
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'),
                            body: {
                                padding: 10,
                                rows: [upper_section2],
                            },
                        },
                    ],
                },
            ],
        };

        // Buttons for clearing and consulting filters
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 },
                        {
                            view: 'button',
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clears the form inputs
                            },
                        },
                        {
                            view: 'button',
                            value: _('Consultar'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Gets the filter values
                                this.app.callEvent('machineProducts:filter', [filterdata]); // Triggers the filter event
                                $$('b1').collapse(); // Collapses the filter section
                                $$('a5').scrollTo(100, 0); // Scrolls to a specific position
                            },
                        },
                    ],
                },
            ],
        };

        // Accordion section for basic filters
        const accordion_section1 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'),
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons],
                            },
                        },
                    ],
                },
            ],
        };

        // Returns the main form configuration
        return {
            view: 'form',
            type: 'clean',
            rows: [accordion_section1],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and fetches categories for the current user.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        const cur_user = this.getParam('user', true); // Retrieves the current user parameter
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'MachineGames/GetCategories', '{"IdMachine":' + cur_user + '"}', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Displays an error message on failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parses the response text
                    $$('Categorie').define('options', resp.data); // Defines the options for the category select
                },
            });
    }
}

// FILE DOCUMENTED
